import { z } from "zod";

const CharterType = z.enum(["bareboat", "skippered", "crewed"]);
const YachtApiStatus = z.enum(["synced", "delayed", "expired"]);
const Brands = z.enum(["Helm", "Anchor"]);

const YachtType = z.enum([
  "Sailing yacht",
  "Catamaran",
  "Do not display",
  "Gulet",
  "Jet ski",
  "Power catamaran",
  "R.I.B / Speed boat",
  "Other",
  "Motor yacht",
]);
const Api = z.enum(["BM", "CYA", "Helm", "NS", "Ankor", "Yachtfolio"]);

export const YachtsFiltersFormT = z.object({
  brand: z.array(Brands).or(z.tuple([])).optional(),
  charterType: z.array(CharterType).or(z.tuple([])).optional(),
  apiStatus: z.array(YachtApiStatus).or(z.tuple([])).optional(),
  boatType: z.array(YachtType).or(z.tuple([])).optional(),
  ignoreDates: z.boolean().optional(),
  provider: z.array(Api).or(z.tuple([])).optional(),
  mainsail: z.array(z.string()).or(z.tuple([])).optional(),
  operator: z.array(z.string()).optional(),
  yachtId: z.string().optional(),
  cabinsMin: z.number().optional(),
  cabinsMax: z.number().optional(),
  bathroomsMin: z.number().optional(),
  bathroomsMax: z.number().optional(),
  lengthMin: z.number().optional(),
  lengthMax: z.number().optional(),
  crewMin: z.number().optional(),
  crewMax: z.number().optional(),
  ratingMin: z.number().optional(),
  ratingMax: z.number().optional(),
  yearMin: z.number().optional(),
  yearMax: z.number().optional(),
  priceMin: z.number().optional(),
  priceMax: z.number().optional(),
  checkIn: z.string().optional(),
  checkOut: z.string().optional(),
  people: z.number().optional(),
  amenities: z.array(z.string()).optional(),
  manufacturer: z.array(z.string()).optional(),
  yachtName: z.array(z.string()).optional(),
  // search related fields
  model: z.array(z.string()).or(z.tuple([])).optional(),
  town: z.array(z.string()).or(z.tuple([])).optional(),
  country: z.array(z.string()).or(z.tuple([])).optional(),
  region: z.array(z.string()).or(z.tuple([])).optional(),
  location: z.array(z.string()).or(z.tuple([])).optional(),
  tlr: z.array(z.string()).or(z.tuple([])).optional(),
});

export type YachtsFiltersFormT = z.infer<typeof YachtsFiltersFormT>;

export const emptyYachtsFiltersForm: YachtsFiltersFormT = {
  brand: [],
  charterType: [],
  apiStatus: [], // ["synced"], TO BE UNCOMMENTED
  boatType: [],
  amenities: [],
  ignoreDates: false,
  provider: [],
  operator: [],
  yachtId: "",
  checkIn: "",
  checkOut: "",
  people: 1,
  model: [],
  country: [],
  region: [],
  location: [],
  town: [],
  manufacturer: [],
  yachtName: [],
  mainsail: [],
  // cabinsMin: 1,
  // cabinsMax: 30,
  // bathroomsMin: 1,
  // bathroomsMax: 10,
  // lengthMin: 12,
  // lengthMax: 18,
  // yearMin: 2000,
  // yearMax: new Date().getFullYear(),
  // priceMin: 500,
  // priceMax: 50000,
};
